import React from 'react';
import styled, { keyframes } from 'styled-components';
import * as color from '@constant/color';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

interface IProps {
  size?: string;
  color?: string;
  // 테두리 두께. 작게 쓸 때는 얇아야 원형이 보인다.
  thickness?: string;
}

const SpinnerWrapper = styled.div<{ size: string; color: string; thickness: string }>`
  display: inline-block;
  width: ${(props) => props.size};
  height: ${(props) => props.size};
  border: ${(props) => props.thickness} solid ${color.GRAY_3};
  border-radius: 50%;
  border-top-color: ${(props) => props.color};
  animation: ${spin} 1s linear infinite;
`;

const Spinner: React.FC<IProps> = ({ size = '20px', color: spinnerColor = color.BLACK_2, thickness = '3px' }) => {
  return <SpinnerWrapper size={size} color={spinnerColor} thickness={thickness} />;
};

export default Spinner;
